import React from 'react';
import withContext from '../../../withContext';

class DueDateSummary extends React.Component {
  calculatePregnancyDetails(dueDateStr) {
    const MS_PER_DAY = 1000 * 60 * 60 * 24;

    const today = new Date();
    const dueDate = new Date(dueDateStr);

    // Calculate remaining days
    const diffInMs = dueDate - today;
    const remainingDays = Math.max(0, Math.floor(diffInMs / MS_PER_DAY));
    const remainingWeeks = Math.floor(remainingDays / 7);
    const remainingExtraDays = remainingDays % 7;

    // Full pregnancy duration = 280 days (40 weeks)
    const totalPregnancyDays = 280;
    const elapsedDays = totalPregnancyDays - remainingDays;
    const currentWeek = Math.floor(elapsedDays / 7);
    const currentDay = elapsedDays % 7;

    let trimester = '';
    if (currentWeek <= 12) {
      trimester = '1st Trimester';
    } else if (currentWeek <= 26) {
      trimester = '2nd Trimester';
    } else {
      trimester = '3rd Trimester';
    }

    return {
      currentWeek,
      currentDay,
      trimester,
      remainingWeeks,
      remainingExtraDays
    };
  }

  render() {
    const data = this.props.location?.state?.dueDateData;

    if (!data || !data.dueDate) {
      return <div>No data received. Please go back and try again.</div>;
    }

    const {
      currentWeek,
      currentDay,
      trimester,
      remainingWeeks,
      remainingExtraDays
    } = this.calculatePregnancyDetails(data.dueDate);

    return (
      <div style={{ padding: '20px' }}>
        <h2>🍼 Due Date Summary</h2>
        <p><strong>Due Date:</strong> {data.dueDate}</p>
        <p><strong>Current Pregnancy Age:</strong> {currentWeek} weeks, {currentDay} days</p>
        <p><strong>Current Trimester:</strong> {trimester}</p>
        <p><strong>Time Remaining:</strong> {remainingWeeks} weeks, {remainingExtraDays} days</p>
      </div>
    );
  }
}

export default withContext(DueDateSummary);
